import request from "../../untils/request.js"


export const getDrugStatistics = (params) => {
    return request.get("/outpatient/ostatis/drug", { params } )
}

export const getDoctorsStatistics = (params) => {
    return request.get("/outpatient/ostatis/otpatDoctor", { params } )
}

export const getFinance = (params) => {
    return request.get("/outpatient/ostatis/finance", { params } )
}
export const getFeelistStaticsByFinance = (params) => {
    return request.get("/outpatient/feelist/staticsByFinance", { params } )
}

export const getRegisterStaticsByFinance = (params) => {
    return request.get("/outpatient/register/staticsByFinance", { params } )
}

export const getProfitReport = (params) => {
    return request.get("/outpatient/boss/profitReport", { params } )
}